// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* --- ГЛАВНЫЙ КОНТЕЙНЕР (ДЕТОНАТОР) --- */
.bomb-container {
  position: fixed;
  top: 50%; left: 50%; transform: translate(-50%, -50%);
  width: 90%; max-width: 340px;
  background: linear-gradient(145deg, #2b2b2b, #1a1a1a);
  border: 1px solid #444; border-bottom: 6px solid #111; border-radius: 16px;
  box-shadow: 0 20px 60px rgba(0,0,0,0.8), inset 0 1px 0 rgba(255,255,255,0.1);
  padding: 20px; display: flex; flex-direction: column; gap: 15px;
  font-family: 'Segoe UI', Roboto, Helvetica, Arial, sans-serif;
  z-index: 6000; -webkit-user-select: none; user-select: none;
}
.bomb-container::before, .bomb-container::after { content: ''; position: absolute; top: 10px; width: 8px; height: 8px; background: #111; border-radius: 50%; box-shadow: 0 1px 0 rgba(255,255,255,0.1); }
.bomb-container::before { left: 10px; } .bomb-container::after { right: 10px; }

/* --- ПАНЕЛЬ И ЭКРАН --- */
.bomb-stats-bar { display: flex; justify-content: space-between; align-items: center; background: #000; padding: 8px 15px; border-radius: 8px; border: 1px solid #333; box-shadow: inset 0 2px 5px rgba(0,0,0,0.5); }
.b-stat-group { display: flex; flex-direction: column; align-items: center; line-height: 1; }
.b-label { font-size: 9px; color: #555; text-transform: uppercase; font-weight: 800; letter-spacing: 0.5px; margin-bottom: 2px; }
.b-value { font-family: 'Courier New', monospace; font-weight: bold; font-size: 18px; color: #fff; text-shadow: 0 0 2px rgba(255,255,255,0.3); }
.b-value.highlight { color: #f1c40f; } .b-value.danger { color: #e74c3c; }

.bomb-screen { background: #080808; height: 140px; border-radius: 6px; border: 2px solid #333; position: relative; overflow: hidden; display: flex; flex-direction: column; align-items: center; justify-content: center; box-shadow: inset 0 0 15px rgba(0,0,0,0.9); }
.bomb-screen::before { content: ''; position: absolute; top: 0; left: 0; right: 0; bottom: 0; background-image: linear-gradient(rgba(30, 255, 30, 0.03) 1px, transparent 1px), linear-gradient(90deg, rgba(30, 255, 30, 0.03) 1px, transparent 1px); background-size: 20px 20px; pointer-events: none; }
.task-wrapper { z-index: 2; text-align: center; width: 100%; padding: 0 10px; }
.task-main-text { font-size: 26px; font-weight: 900; text-transform: uppercase; letter-spacing: 1px; text-shadow: 0 0 10px rgba(0,0,0,0.5); line-height: 1.1; }
.text-red { color: #ff3333; text-shadow: 0 0 5px rgba(255, 51, 51, 0.4); }
.text-blue { color: #3388ff; text-shadow: 0 0 5px rgba(51, 136, 255, 0.4); }
.text-green { color: #33ff33; text-shadow: 0 0 5px rgba(51, 255, 51, 0.4); }
.text-yellow { color: #ffff33; text-shadow: 0 0 5px rgba(255, 255, 51, 0.4); }

.timer-bar-container { position: absolute; bottom: 0; left: 0; right: 0; height: 8px; background: #111; }
.timer-bar-fill { height: 100%; background: linear-gradient(90deg, #d23625, #b46c64); box-shadow: 0 0 10px #e74c3c; transition: width 0.05s linear; }
.boom-overlay { position: absolute; inset: 0; background: rgba(200, 0, 0, 0.9); display: flex; align-items: center; justify-content: center; z-index: 10; animation: flash 0.2s ease-out; }
.boom-text { font-size: 40px; font-weight: 900; color: #fff; border: 4px solid #fff; padding: 5px 15px; transform: rotate(-10deg); text-transform: uppercase; }

/* --- ПРОВОДА (КНОПКИ) --- */
.wires-grid {
  display: grid; grid-template-columns: 1fr 1fr; gap: 12px; margin-top: 5px;
  position: relative; z-index: 20;
}

.wire-btn {
  background: #222; border-radius: 6px; height: 70px;
  position: relative; /* Для z-index */
  box-shadow: 0 4px 0 #000;
  transition: transform 0.05s;
  display: flex; align-items: center; justify-content: center;
  padding: 0 10px;
  overflow: visible; /* Чтобы кусачки торчали */
  -webkit-user-select: none;
          user-select: none;
}

.wire-btn:active { transform: translateY(2px); box-shadow: 0 2px 0 #000; }

/* --- ВИЗУАЛ ПРОВОДА --- */
/* ВАЖНО: pointer-events: none, чтобы elementFromPoint попадал в wire-btn */
.wire-visual {
  width: 100%; height: 12px; border-radius: 4px; position: relative;
  box-shadow: inset 0 3px 3px rgba(255,255,255,0.3), inset 0 -3px 3px rgba(0,0,0,0.3), 0 2px 4px rgba(0,0,0,0.5);
  z-index: 1; pointer-events: none;
}
.wire-visual::before, .wire-visual::after { content: ''; position: absolute; top: -2px; width: 10px; height: 16px; background: #111; border-radius: 2px; box-shadow: 0 1px 0 rgba(255,255,255,0.1); z-index: 2; }
.wire-visual::before { left: -12px; } .wire-visual::after { right: -12px; }
.btn-red .wire-visual { background: #e74c3c; } .btn-blue .wire-visual { background: #3498db; } .btn-green .wire-visual { background: #2ecc71; } .btn-yellow .wire-visual { background: #f1c40f; }

.cut-gap-visual { position: absolute; left: 50%; top: 50%; transform: translate(-50%, -50%); width: 14px; height: 16px; background: #222; z-index: 3; display: flex; justify-content: space-between; align-items: center; }
.copper-bit { width: 3px; height: 6px; background: linear-gradient(to bottom, #d48d56, #f5cba7, #a05a2c); border-radius: 1px; }
.wire-is-cut { opacity: 0.9; }

/* --- ИНСТРУМЕНТ (КУСАЧКИ) --- */
.wire-cutter-tool {
  position: absolute;
  bottom: -150px; left: 50%; transform: translateX(-50%) scale(0.9);
  width: 70px; height: 140px;
  z-index: 100; opacity: 0;
  pointer-events: none; /* ПРОПУСКАЕТ КЛИКИ */
  transition: bottom 0.1s ease-out, opacity 0.1s ease-in;
}

.wire-cutter-tool.visible {
  bottom: -95px; /* Высота, чтобы кончик касался провода */
  opacity: 1; transform: translateX(-50%) scale(1);
}

/* Лезвия (Монолитные) */
.cutter-jaws {
  width: 100%; height: 35%;
  clip-path: polygon(20% 100%, 50% 0%, 80% 100%);
  background: conic-gradient(from 180deg at 50% 100%, #555 0deg, #999 45deg, #fff 55deg, #888 65deg, #444 90deg, #888 115deg, #fff 125deg, #999 135deg, #555 180deg);
  position: relative; z-index: 2;
  filter: drop-shadow(0 5px 5px rgba(0,0,0,0.5));
}

/* Ручки (Красные, без щели) */
.cutter-handles {
  width: 70%; height: 65%; margin: 0 auto;
  background: linear-gradient(90deg, #800000, #ff0000 30%, #ff0000 70%, #800000);
  clip-path: polygon(0% 0%, 100% 0%, 85% 100%, 15% 100%);
  position: relative; top: -1px; z-index: 1;
  box-shadow: inset 0 0 10px rgba(0,0,0,0.5);
}

/* Анимации и прочее */
@keyframes shake { 10%, 90% { transform: translate(-50%, -50%) translate(-2px, 0); } 20%, 80% { transform: translate(-50%, -50%) translate(4px, 0); } 30%, 50%, 70% { transform: translate(-50%, -50%) translate(-6px, 0); } 40%, 60% { transform: translate(-50%, -50%) translate(6px, 0); } }
.shake-anim { animation: shake 0.4s cubic-bezier(.36,.07,.19,.97) both; }

/* Модалка результатов */
.bomb-result-modal { background: #f4f4f4; width: 90%; max-width: 320px; padding: 25px; border-radius: 4px; text-align: center; position: relative; box-shadow: 0 20px 50px rgba(0,0,0,0.5); transform: rotate(-1deg); color: #333; font-family: 'Courier New', monospace; }
.bomb-result-modal::before { content: ''; position: absolute; top: -15px; left: 50%; transform: translateX(-50%); width: 15px; height: 40px; background: #999; border-radius: 10px; z-index: 2; box-shadow: 1px 1px 2px rgba(0,0,0,0.3); }
.result-header h2 { margin: 0; font-size: 24px; text-transform: uppercase; border-bottom: 2px solid #333; padding-bottom: 10px; margin-bottom: 20px; }
.result-stats { margin-bottom: 25px; font-size: 16px; display: flex; flex-direction: column; gap: 10px; }
.res-row { display: flex; justify-content: space-between; border-bottom: 1px dashed #ccc; padding-bottom: 3px; }
.res-val { font-weight: bold; font-size: 20px; }
.result-stamp { font-size: 32px; font-weight: 900; text-transform: uppercase; border: 5px double; padding: 5px 10px; display: inline-block; transform: rotate(-15deg); opacity: 0; animation: stampIn 0.4s 0.2s cubic-bezier(0.175, 0.885, 0.32, 1.275) forwards; margin-bottom: 20px; }
.stamp-win { color: #27ae60; border-color: #27ae60; } .stamp-fail { color: #c0392b; border-color: #c0392b; }
@keyframes stampIn { from { opacity: 0; transform: rotate(-15deg) scale(2); } to { opacity: 0.8; transform: rotate(-15deg) scale(1); } }
.result-btn { background: #333; color: #fff; border: none; padding: 12px 24px; font-size: 16px; font-family: inherit; font-weight: bold; cursor: pointer; width: 100%; text-transform: uppercase; transition: background 0.2s; }
.result-btn:active { background: #000; }
@keyframes flash { from { opacity: 0; } to { opacity: 1; } }

/* Болтики по углам */
.bomb-container::before, .bomb-container::after {
  content: '';
  position: absolute;
  top: 10px;
  width: 8px;
  height: 8px;
  background: #111;
  border-radius: 50%;
  box-shadow: 0 1px 0 rgba(255,255,255,0.1);
}
.bomb-container::before { left: 10px; }
.bomb-container::after { right: 10px; }

/* --- ВЕРХНЯЯ ПАНЕЛЬ (ИНФО) --- */
.bomb-stats-bar {
  display: flex;
  justify-content: space-between;
  align-items: center;
  background: #000;
  padding: 8px 15px;
  border-radius: 8px;
  border: 1px solid #333;
  box-shadow: inset 0 2px 5px rgba(0,0,0,0.5);
}

.b-stat-group {
  display: flex;
  flex-direction: column;
  align-items: center;
  line-height: 1;
}

.b-label {
  font-size: 9px;
  color: #555;
  text-transform: uppercase;
  font-weight: 800;
  letter-spacing: 0.5px;
  margin-bottom: 2px;
}

.b-value {
  font-family: 'Courier New', monospace;
  font-weight: bold;
  font-size: 18px;
  color: #fff;
  text-shadow: 0 0 2px rgba(255,255,255,0.3);
}

.b-value.highlight { color: #f1c40f; }
.b-value.danger { color: #e74c3c; }

/* --- ЭКРАН ЗАДАЧИ --- */
.bomb-screen {
  background: #080808;
  height: 140px;
  border-radius: 6px;
  border: 2px solid #333;
  position: relative;
  overflow: hidden;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  box-shadow: inset 0 0 15px rgba(0,0,0,0.9);
}

/* Сетка на экране (декор) */
.bomb-screen::before {
  content: '';
  position: absolute;
  top: 0; left: 0; right: 0; bottom: 0;
  background-image:
    linear-gradient(rgba(30, 255, 30, 0.03) 1px, transparent 1px),
    linear-gradient(90deg, rgba(30, 255, 30, 0.03) 1px, transparent 1px);
  background-size: 20px 20px;
  pointer-events: none;
}

.task-wrapper {
  z-index: 2;
  text-align: center;
  width: 100%;
  padding: 0 10px;
}

.task-main-text {
  font-size: 26px; /* Крупнее, раз убрали иконки */
  font-weight: 900;
  text-transform: uppercase;
  letter-spacing: 1px;
  text-shadow: 0 0 10px rgba(0,0,0,0.5);
  line-height: 1.1;
}

/* Цвета текста */
.text-red { color: #ff3333; text-shadow: 0 0 5px rgba(255, 51, 51, 0.4); }
.text-blue { color: #3388ff; text-shadow: 0 0 5px rgba(51, 136, 255, 0.4); }
.text-green { color: #33ff33; text-shadow: 0 0 5px rgba(51, 255, 51, 0.4); }
.text-yellow { color: #ffff33; text-shadow: 0 0 5px rgba(255, 255, 51, 0.4); }

/* Таймер-полоска */
.timer-bar-container {
  position: absolute;
  bottom: 0;
  left: 0;
  right: 0;
  height: 8px;
  background: #111;
}

.timer-bar-fill {
  height: 100%;
  background: linear-gradient(90deg, #d23625, #b46c64);
  box-shadow: 0 0 10px #e74c3c;
  transition: width 0.05s linear;
}

/* Оверлей взрыва */
.boom-overlay {
  position: absolute;
  inset: 0;
  background: rgba(200, 0, 0, 0.9);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 10;
  animation: flash 0.2s ease-out;
}
.boom-text {
  font-size: 40px;
  font-weight: 900;
  color: #fff;
  border: 4px solid #fff;
  padding: 5px 15px;
  transform: rotate(-10deg);
  text-transform: uppercase;
}

/* --- ПРОВОДА И СЕТКА --- */
.wires-grid {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 12px;
  margin-top: 5px;

  /* Разрешаем элементам выходить за границы сетки (для ручек кусачек) */
  position: relative;
  z-index: 20;
}

.wire-btn {
  background: #222;
  border-radius: 6px;
  height: 70px;
  position: relative; /* Важно для z-index */
  box-shadow: 0 4px 0 #000;
  transition: transform 0.05s;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 0 10px;
  overflow: visible;
  -webkit-user-select: none;
          user-select: none;
  cursor: crosshair;
}

.wire-btn:active {
  /* Убираем сильное смещение кнопки, так как мы теперь "водим" инструментом */
  transform: translateY(1px);
  box-shadow: 0 3px 0 #000;
}

/* Черные клеммы по бокам */
.wire-visual::before, .wire-visual::after {
  content: '';
  position: absolute;
  top: -2px;
  width: 10px;
  height: 16px;
  background: #111;
  border-radius: 2px;
  box-shadow: 0 1px 0 rgba(255,255,255,0.1);
  z-index: 2; /* Поверх провода */
}
.wire-visual::before { left: -12px; }
.wire-visual::after { right: -12px; }

/* Провод: ВАЖНО pointer-events: none */
.wire-visual {
  width: 100%; height: 12px; border-radius: 4px; position: relative;
  box-shadow: inset 0 3px 3px rgba(255,255,255,0.3), inset 0 -3px 3px rgba(0,0,0,0.3), 0 2px 4px rgba(0,0,0,0.5);
  z-index: 1;
  pointer-events: none;
}

/* Цвета проводов */
.btn-red .wire-visual { background: #e74c3c; }
.btn-blue .wire-visual { background: #3498db; }
.btn-green .wire-visual { background: #2ecc71; }
.btn-yellow .wire-visual { background: #f1c40f; }

/* --- ЭФФЕКТ РАЗРЕЗА --- */

/* Контейнер разрыва по центру */
.cut-gap-visual {
  position: absolute;
  left: 50%;
  top: 50%;
  transform: translate(-50%, -50%);
  width: 14px;
  height: 16px;
  background: #222; /* Цвет должен совпадать с фоном кнопки */
  z-index: 3;
  display: flex;
  justify-content: space-between;
  align-items: center;
}

/* Медные кончики */
.copper-bit {
  width: 3px;
  height: 6px; /* Уже чем сам провод (12px) */
  background: linear-gradient(to bottom, #d48d56, #f5cba7, #a05a2c); /* Медный цвет */
  border-radius: 1px;
}
.copper-bit.left { margin-left: -1px; }
.copper-bit.right { margin-right: -1px; }

/* Состояние: провод перерезан */
.wire-is-cut {
  cursor: default;
  pointer-events: none;
  opacity: 0.9;
}
/* Убираем тень при нажатии для перерезанного (чтобы не прыгал) */
.wire-is-cut:active {
  transform: none;
  box-shadow: 0 4px 0 #000;
}


/* --- ИНСТРУМЕНТ (КУСАЧКИ) --- */

.wire-cutter-tool {
  position: absolute;
  bottom: -150px;
  left: 50%;
  transform: translateX(-50%) scale(0.9);
  width: 70px;
  height: 140px;
  z-index: 100;
  opacity: 0;
  /* ВАЖНО: Пропускаем клики сквозь инструмент, чтобы попасть в кнопку */
  pointer-events: none;
  transition: bottom 0.1s ease-out, opacity 0.1s ease-in;
}

/* АКТИВНЫЕ КУСАЧКИ */
.wire-cutter-tool.visible {
  /* Опускаем ниже: провод на высоте ~35px от низа кнопки. */
  /* Высота кусачек 140px. Если bottom -100px, верх кусачек на высоте 40px */
  bottom: -95px;
  opacity: 1;
  transform: translateX(-50%) scale(1);
}

/* 1. Лезвия (Верх) - МОНОЛИТНЫЕ */
.cutter-jaws {
  width: 100%;
  height: 35%; /* Чуть короче, чтобы больше ручек было */

  /* Форма: монолитный конус/трапеция, без щели */
  clip-path: polygon(
    20% 100%,  /* Левый низ */
    50% 0%,    /* ОСТРИЕ (Верх) */
    80% 100%   /* Правый низ */
  );

  /* Металлический градиент */
  background: conic-gradient(
    from 180deg at 50% 100%,
    #555 0deg, #999 45deg, #fff 55deg, #888 65deg,
    #444 90deg,
    #888 115deg, #fff 125deg, #999 135deg, #555 180deg
  );

  position: relative;
  z-index: 2;
  filter: drop-shadow(0 5px 5px rgba(0,0,0,0.5));
}

.cutter-handles {
  width: 70%;
  height: 65%;
  margin: 0 auto;

  /* Исправлен цвет на яркий, непрозрачный красный */
  background: linear-gradient(90deg, #800000, #ff0000 30%, #ff0000 70%, #800000);

  clip-path: polygon(
    0% 0%,
    100% 0%,
    85% 100%,
    15% 100%
  );

  position: relative;
  top: -1px;
  z-index: 1;
  box-shadow: inset 0 0 10px rgba(0,0,0,0.5);
}

/* Анимация тряски */
@keyframes shake {
  10%, 90% { transform: translate(-50%, -50%) translate(-2px, 0); }
  20%, 80% { transform: translate(-50%, -50%) translate(4px, 0); }
  30%, 50%, 70% { transform: translate(-50%, -50%) translate(-6px, 0); }
  40%, 60% { transform: translate(-50%, -50%) translate(6px, 0); }
}
.shake-anim {
  animation: shake 0.4s cubic-bezier(.36,.07,.19,.97) both;
}

/* --- РЕЗУЛЬТАТЫ (НОВАЯ КАРТОЧКА) --- */
.bomb-result-modal {
  background: #f4f4f4;
  width: 90%;
  max-width: 320px; /* Ограничиваем ширину */
  padding: 25px;
  border-radius: 4px;
  text-align: center;
  position: relative;
  box-shadow: 0 20px 50px rgba(0,0,0,0.5);
  transform: rotate(-1deg); /* Эффект бумаги */
  color: #333;
  font-family: 'Courier New', monospace;
}

/* Скрепка */
.bomb-result-modal::before {
  content: '';
  position: absolute;
  top: -15px;
  left: 50%;
  transform: translateX(-50%);
  width: 15px;
  height: 40px;
  background: #999;
  border-radius: 10px;
  z-index: 2;
  box-shadow: 1px 1px 2px rgba(0,0,0,0.3);
}

.result-header h2 {
  margin: 0;
  font-size: 24px;
  text-transform: uppercase;
  border-bottom: 2px solid #333;
  padding-bottom: 10px;
  margin-bottom: 20px;
}

.result-stats {
  margin-bottom: 25px;
  font-size: 16px;
  display: flex;
  flex-direction: column;
  gap: 10px;
}

.res-row {
  display: flex;
  justify-content: space-between;
  border-bottom: 1px dashed #ccc;
  padding-bottom: 3px;
}

.res-val {
  font-weight: bold;
  font-size: 20px;
}

.result-stamp {
  font-size: 32px;
  font-weight: 900;
  text-transform: uppercase;
  border: 5px double;
  padding: 5px 10px;
  display: inline-block;
  transform: rotate(-15deg);
  opacity: 0;
  animation: stampIn 0.4s 0.2s cubic-bezier(0.175, 0.885, 0.32, 1.275) forwards;
  margin-bottom: 20px;
}

.stamp-win { color: #27ae60; border-color: #27ae60; }
.stamp-fail { color: #c0392b; border-color: #c0392b; }

@keyframes stampIn {
  from { opacity: 0; transform: rotate(-15deg) scale(2); }
  to { opacity: 0.8; transform: rotate(-15deg) scale(1); }
}

.result-btn {
  background: #333;
  color: #fff;
  border: none;
  padding: 12px 24px;
  font-size: 16px;
  font-family: inherit;
  font-weight: bold;
  cursor: pointer;
  width: 100%;
  text-transform: uppercase;
  transition: background 0.2s;
}
.result-btn:active { background: #000; }

@keyframes flash {
  from { opacity: 0; }
  to { opacity: 1; }
}

/* --- ЭФФЕКТЫ (FX) --- */

/* Контейнер эффектов: Центрируется ровно в месте разреза */
.fx-container {
  position: absolute;
  top: 50%; left: 50%;
  transform: translate(-50%, -50%);
  width: 0; height: 0;
  pointer-events: none;
  z-index: 20; /* Поверх медных концов */
}

/* 1. ДЫМОК */
.fx-smoke {
  position: absolute;
  width: 20px; height: 20px;
  background: radial-gradient(circle, rgba(200,200,200,0.8) 0%, rgba(100,100,100,0) 70%);
  border-radius: 50%;
  top: -5px; left: -10px;
  opacity: 0;
  animation: puffSmoke 0.5s ease-out forwards;
}

@keyframes puffSmoke {
  0% { transform: scale(0.5) translateY(0); opacity: 0.8; }
  100% { transform: scale(2.5) translateY(-30px); opacity: 0; }
}

/* 2. ИСКРЫ */
.fx-spark {
  position: absolute;
  width: 4px; height: 4px;
  background: #fff;
  border-radius: 50%;
  box-shadow: 0 0 4px #ffcc00, 0 0 8px #ff6600;
  opacity: 0;
}

/* Разные направления полета искр */
.s1 { animation: sparkFly 0.3s ease-out forwards; --dx: -15px; --dy: -20px; }
.s2 { animation: sparkFly 0.4s ease-out 0.05s forwards; --dx: 15px; --dy: -25px; }
.s3 { animation: sparkFly 0.3s ease-out 0.02s forwards; --dx: -10px; --dy: 10px; }
.s4 { animation: sparkFly 0.35s ease-out forwards; --dx: 10px; --dy: 15px; }

@keyframes sparkFly {
  0% { transform: translate(0, 0) scale(1); opacity: 1; background: #ffffcc; }
  50% { opacity: 1; }
  100% { transform: translate(var(--dx), var(--dy)) scale(0); opacity: 0; background: #ff4400; }
}

/* --- НОВЫЕ СТИЛИ ДЛЯ SURVIVAL MODE --- */

/* Отображение ошибок */
.strikes-container {
  display: flex;
  gap: 4px;
}

.strike-icon {
  color: #e74c3c;
  font-size: 18px;
}

.strike-icon.inactive {
  color: #333;
}

/* Таймер выживания */
.survival-timer.danger {
  color: #ff3333;
  animation: pulse 0.5s infinite alternate;
}

@keyframes pulse {
  from { opacity: 1; }
  to { opacity: 0.6; }
}

/* Состояния конца игры */
.stamp-exploded {
  color: #e74c3c;
  border-color: #e74c3c;
  text-shadow: 0 0 10px rgba(231, 76, 60, 0.8);
}

.stamp-survived {
  color: #27ae60;
  border-color: #27ae60;
  text-shadow: 0 0 10px rgba(39, 174, 96, 0.8);
}`, "",{"version":3,"sources":["webpack://./src/components/arcade/games/bomb/BombDefusal.css"],"names":[],"mappings":"AAAA,0CAA0C;AAC1C;EACE,eAAe;EACf,QAAQ,EAAE,SAAS,EAAE,gCAAgC;EACrD,UAAU,EAAE,gBAAgB;EAC5B,qDAAqD;EACrD,sBAAsB,EAAE,6BAA6B,EAAE,mBAAmB;EAC1E,4EAA4E;EAC5E,aAAa,EAAE,aAAa,EAAE,sBAAsB,EAAE,SAAS;EAC/D,6DAA6D;EAC7D,aAAa,EAAE,yBAAiB,EAAjB,iBAAiB;AAClC;AACA,kDAAkD,WAAW,EAAE,kBAAkB,EAAE,SAAS,EAAE,UAAU,EAAE,WAAW,EAAE,gBAAgB,EAAE,kBAAkB,EAAE,yCAAyC,EAAE;AACxM,0BAA0B,UAAU,EAAE,EAAE,yBAAyB,WAAW,EAAE;;AAE9E,2BAA2B;AAC3B,kBAAkB,aAAa,EAAE,8BAA8B,EAAE,mBAAmB,EAAE,gBAAgB,EAAE,iBAAiB,EAAE,kBAAkB,EAAE,sBAAsB,EAAE,2CAA2C,EAAE;AACpN,gBAAgB,aAAa,EAAE,sBAAsB,EAAE,mBAAmB,EAAE,cAAc,EAAE;AAC5F,WAAW,cAAc,EAAE,WAAW,EAAE,yBAAyB,EAAE,gBAAgB,EAAE,qBAAqB,EAAE,kBAAkB,EAAE;AAChI,WAAW,qCAAqC,EAAE,iBAAiB,EAAE,eAAe,EAAE,WAAW,EAAE,0CAA0C,EAAE;AAC/I,qBAAqB,cAAc,EAAE,EAAE,kBAAkB,cAAc,EAAE;;AAEzE,eAAe,mBAAmB,EAAE,aAAa,EAAE,kBAAkB,EAAE,sBAAsB,EAAE,kBAAkB,EAAE,gBAAgB,EAAE,aAAa,EAAE,sBAAsB,EAAE,mBAAmB,EAAE,uBAAuB,EAAE,0CAA0C,EAAE;AACtQ,uBAAuB,WAAW,EAAE,kBAAkB,EAAE,MAAM,EAAE,OAAO,EAAE,QAAQ,EAAE,SAAS,EAAE,qJAAqJ,EAAE,0BAA0B,EAAE,oBAAoB,EAAE;AACvS,gBAAgB,UAAU,EAAE,kBAAkB,EAAE,WAAW,EAAE,eAAe,EAAE;AAC9E,kBAAkB,eAAe,EAAE,gBAAgB,EAAE,yBAAyB,EAAE,mBAAmB,EAAE,qCAAqC,EAAE,gBAAgB,EAAE;AAC9J,YAAY,cAAc,EAAE,2CAA2C,EAAE;AACzE,aAAa,cAAc,EAAE,4CAA4C,EAAE;AAC3E,cAAc,cAAc,EAAE,2CAA2C,EAAE;AAC3E,eAAe,cAAc,EAAE,4CAA4C,EAAE;;AAE7E,uBAAuB,kBAAkB,EAAE,SAAS,EAAE,OAAO,EAAE,QAAQ,EAAE,WAAW,EAAE,gBAAgB,EAAE;AACxG,kBAAkB,YAAY,EAAE,oDAAoD,EAAE,4BAA4B,EAAE,8BAA8B,EAAE;AACpJ,gBAAgB,kBAAkB,EAAE,QAAQ,EAAE,gCAAgC,EAAE,aAAa,EAAE,mBAAmB,EAAE,uBAAuB,EAAE,WAAW,EAAE,8BAA8B,EAAE;AAC1L,aAAa,eAAe,EAAE,gBAAgB,EAAE,WAAW,EAAE,sBAAsB,EAAE,iBAAiB,EAAE,yBAAyB,EAAE,yBAAyB,EAAE;;AAE9J,6BAA6B;AAC7B;EACE,aAAa,EAAE,8BAA8B,EAAE,SAAS,EAAE,eAAe;EACzE,kBAAkB,EAAE,WAAW;AACjC;;AAEA;EACE,gBAAgB,EAAE,kBAAkB,EAAE,YAAY;EAClD,kBAAkB,EAAE,gBAAgB;EACpC,wBAAwB;EACxB,2BAA2B;EAC3B,aAAa,EAAE,mBAAmB,EAAE,uBAAuB;EAC3D,eAAe;EACf,iBAAiB,EAAE,0BAA0B;EAC7C,yBAAiB;UAAjB,iBAAiB;AACnB;;AAEA,mBAAmB,0BAA0B,EAAE,wBAAwB,EAAE;;AAEzE,2BAA2B;AAC3B,2EAA2E;AAC3E;EACE,WAAW,EAAE,YAAY,EAAE,kBAAkB,EAAE,kBAAkB;EACjE,8GAA8G;EAC9G,UAAU,EAAE,oBAAoB;AAClC;AACA,4CAA4C,WAAW,EAAE,kBAAkB,EAAE,SAAS,EAAE,WAAW,EAAE,YAAY,EAAE,gBAAgB,EAAE,kBAAkB,EAAE,yCAAyC,EAAE,UAAU,EAAE;AAChN,uBAAuB,WAAW,EAAE,EAAE,sBAAsB,YAAY,EAAE;AAC1E,wBAAwB,mBAAmB,EAAE,EAAE,yBAAyB,mBAAmB,EAAE,EAAE,0BAA0B,mBAAmB,EAAE,EAAE,2BAA2B,mBAAmB,EAAE;;AAEhM,kBAAkB,kBAAkB,EAAE,SAAS,EAAE,QAAQ,EAAE,gCAAgC,EAAE,WAAW,EAAE,YAAY,EAAE,gBAAgB,EAAE,UAAU,EAAE,aAAa,EAAE,8BAA8B,EAAE,mBAAmB,EAAE;AAC1N,cAAc,UAAU,EAAE,WAAW,EAAE,iEAAiE,EAAE,kBAAkB,EAAE;AAC9H,eAAe,YAAY,EAAE;;AAE7B,iCAAiC;AACjC;EACE,kBAAkB;EAClB,cAAc,EAAE,SAAS,EAAE,sCAAsC;EACjE,WAAW,EAAE,aAAa;EAC1B,YAAY,EAAE,UAAU;EACxB,oBAAoB,EAAE,qBAAqB;EAC3C,sDAAsD;AACxD;;AAEA;EACE,aAAa,EAAE,yCAAyC;EACxD,UAAU,EAAE,oCAAoC;AAClD;;AAEA,wBAAwB;AACxB;EACE,WAAW,EAAE,WAAW;EACxB,8CAA8C;EAC9C,kKAAkK;EAClK,kBAAkB,EAAE,UAAU;EAC9B,8CAA8C;AAChD;;AAEA,8BAA8B;AAC9B;EACE,UAAU,EAAE,WAAW,EAAE,cAAc;EACvC,8EAA8E;EAC9E,sDAAsD;EACtD,kBAAkB,EAAE,SAAS,EAAE,UAAU;EACzC,0CAA0C;AAC5C;;AAEA,sBAAsB;AACtB,mBAAmB,WAAW,mDAAmD,EAAE,EAAE,WAAW,kDAAkD,EAAE,EAAE,gBAAgB,mDAAmD,EAAE,EAAE,WAAW,kDAAkD,EAAE,EAAE;AAC9R,cAAc,wDAAwD,EAAE;;AAExE,wBAAwB;AACxB,qBAAqB,mBAAmB,EAAE,UAAU,EAAE,gBAAgB,EAAE,aAAa,EAAE,kBAAkB,EAAE,kBAAkB,EAAE,kBAAkB,EAAE,uCAAuC,EAAE,wBAAwB,EAAE,WAAW,EAAE,qCAAqC,EAAE;AAC1Q,6BAA6B,WAAW,EAAE,kBAAkB,EAAE,UAAU,EAAE,SAAS,EAAE,2BAA2B,EAAE,WAAW,EAAE,YAAY,EAAE,gBAAgB,EAAE,mBAAmB,EAAE,UAAU,EAAE,uCAAuC,EAAE;AACzO,oBAAoB,SAAS,EAAE,eAAe,EAAE,yBAAyB,EAAE,6BAA6B,EAAE,oBAAoB,EAAE,mBAAmB,EAAE;AACrJ,gBAAgB,mBAAmB,EAAE,eAAe,EAAE,aAAa,EAAE,sBAAsB,EAAE,SAAS,EAAE;AACxG,WAAW,aAAa,EAAE,8BAA8B,EAAE,8BAA8B,EAAE,mBAAmB,EAAE;AAC/G,WAAW,iBAAiB,EAAE,eAAe,EAAE;AAC/C,gBAAgB,eAAe,EAAE,gBAAgB,EAAE,yBAAyB,EAAE,kBAAkB,EAAE,iBAAiB,EAAE,qBAAqB,EAAE,yBAAyB,EAAE,UAAU,EAAE,6EAA6E,EAAE,mBAAmB,EAAE;AACvR,aAAa,cAAc,EAAE,qBAAqB,EAAE,EAAE,cAAc,cAAc,EAAE,qBAAqB,EAAE;AAC3G,qBAAqB,OAAO,UAAU,EAAE,kCAAkC,EAAE,EAAE,KAAK,YAAY,EAAE,kCAAkC,EAAE,EAAE;AACvI,cAAc,gBAAgB,EAAE,WAAW,EAAE,YAAY,EAAE,kBAAkB,EAAE,eAAe,EAAE,oBAAoB,EAAE,iBAAiB,EAAE,eAAe,EAAE,WAAW,EAAE,yBAAyB,EAAE,2BAA2B,EAAE;AAC/N,qBAAqB,gBAAgB,EAAE;AACvC,mBAAmB,OAAO,UAAU,EAAE,EAAE,KAAK,UAAU,EAAE,EAAE;;AAE3D,qBAAqB;AACrB;EACE,WAAW;EACX,kBAAkB;EAClB,SAAS;EACT,UAAU;EACV,WAAW;EACX,gBAAgB;EAChB,kBAAkB;EAClB,yCAAyC;AAC3C;AACA,0BAA0B,UAAU,EAAE;AACtC,yBAAyB,WAAW,EAAE;;AAEtC,kCAAkC;AAClC;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,gBAAgB;EAChB,iBAAiB;EACjB,kBAAkB;EAClB,sBAAsB;EACtB,2CAA2C;AAC7C;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,WAAW;EACX,yBAAyB;EACzB,gBAAgB;EAChB,qBAAqB;EACrB,kBAAkB;AACpB;;AAEA;EACE,qCAAqC;EACrC,iBAAiB;EACjB,eAAe;EACf,WAAW;EACX,0CAA0C;AAC5C;;AAEA,qBAAqB,cAAc,EAAE;AACrC,kBAAkB,cAAc,EAAE;;AAElC,yBAAyB;AACzB;EACE,mBAAmB;EACnB,aAAa;EACb,kBAAkB;EAClB,sBAAsB;EACtB,kBAAkB;EAClB,gBAAgB;EAChB,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,0CAA0C;AAC5C;;AAEA,4BAA4B;AAC5B;EACE,WAAW;EACX,kBAAkB;EAClB,MAAM,EAAE,OAAO,EAAE,QAAQ,EAAE,SAAS;EACpC;;wEAEsE;EACtE,0BAA0B;EAC1B,oBAAoB;AACtB;;AAEA;EACE,UAAU;EACV,kBAAkB;EAClB,WAAW;EACX,eAAe;AACjB;;AAEA;EACE,eAAe,EAAE,+BAA+B;EAChD,gBAAgB;EAChB,yBAAyB;EACzB,mBAAmB;EACnB,qCAAqC;EACrC,gBAAgB;AAClB;;AAEA,iBAAiB;AACjB,YAAY,cAAc,EAAE,2CAA2C,EAAE;AACzE,aAAa,cAAc,EAAE,4CAA4C,EAAE;AAC3E,cAAc,cAAc,EAAE,2CAA2C,EAAE;AAC3E,eAAe,cAAc,EAAE,4CAA4C,EAAE;;AAE7E,mBAAmB;AACnB;EACE,kBAAkB;EAClB,SAAS;EACT,OAAO;EACP,QAAQ;EACR,WAAW;EACX,gBAAgB;AAClB;;AAEA;EACE,YAAY;EACZ,oDAAoD;EACpD,4BAA4B;EAC5B,8BAA8B;AAChC;;AAEA,mBAAmB;AACnB;EACE,kBAAkB;EAClB,QAAQ;EACR,gCAAgC;EAChC,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,8BAA8B;AAChC;AACA;EACE,eAAe;EACf,gBAAgB;EAChB,WAAW;EACX,sBAAsB;EACtB,iBAAiB;EACjB,yBAAyB;EACzB,yBAAyB;AAC3B;;AAEA,4BAA4B;AAC5B;EACE,aAAa;EACb,8BAA8B;EAC9B,SAAS;EACT,eAAe;;EAEf,sEAAsE;EACtE,kBAAkB;EAClB,WAAW;AACb;;AAEA;EACE,gBAAgB;EAChB,kBAAkB;EAClB,YAAY;EACZ,kBAAkB,EAAE,sBAAsB;EAC1C,wBAAwB;EACxB,2BAA2B;EAC3B,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;EACf,iBAAiB;EACjB,yBAAiB;UAAjB,iBAAiB;EACjB,iBAAiB;AACnB;;AAEA;EACE,4EAA4E;EAC5E,0BAA0B;EAC1B,wBAAwB;AAC1B;;AAEA,2BAA2B;AAC3B;EACE,WAAW;EACX,kBAAkB;EAClB,SAAS;EACT,WAAW;EACX,YAAY;EACZ,gBAAgB;EAChB,kBAAkB;EAClB,yCAAyC;EACzC,UAAU,EAAE,mBAAmB;AACjC;AACA,uBAAuB,WAAW,EAAE;AACpC,sBAAsB,YAAY,EAAE;;AAEpC,uCAAuC;AACvC;EACE,WAAW,EAAE,YAAY,EAAE,kBAAkB,EAAE,kBAAkB;EACjE,8GAA8G;EAC9G,UAAU;EACV,oBAAoB;AACtB;;AAEA,mBAAmB;AACnB,wBAAwB,mBAAmB,EAAE;AAC7C,yBAAyB,mBAAmB,EAAE;AAC9C,0BAA0B,mBAAmB,EAAE;AAC/C,2BAA2B,mBAAmB,EAAE;;AAEhD,2BAA2B;;AAE3B,gCAAgC;AAChC;EACE,kBAAkB;EAClB,SAAS;EACT,QAAQ;EACR,gCAAgC;EAChC,WAAW;EACX,YAAY;EACZ,gBAAgB,EAAE,yCAAyC;EAC3D,UAAU;EACV,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;AACrB;;AAEA,mBAAmB;AACnB;EACE,UAAU;EACV,WAAW,EAAE,8BAA8B;EAC3C,iEAAiE,EAAE,gBAAgB;EACnF,kBAAkB;AACpB;AACA,mBAAmB,iBAAiB,EAAE;AACtC,oBAAoB,kBAAkB,EAAE;;AAExC,gCAAgC;AAChC;EACE,eAAe;EACf,oBAAoB;EACpB,YAAY;AACd;AACA,iEAAiE;AACjE;EACE,eAAe;EACf,wBAAwB;AAC1B;;;AAGA,iCAAiC;;AAEjC;EACE,kBAAkB;EAClB,cAAc;EACd,SAAS;EACT,sCAAsC;EACtC,WAAW;EACX,aAAa;EACb,YAAY;EACZ,UAAU;EACV,sEAAsE;EACtE,oBAAoB;EACpB,sDAAsD;AACxD;;AAEA,qBAAqB;AACrB;EACE,0DAA0D;EAC1D,0EAA0E;EAC1E,aAAa;EACb,UAAU;EACV,oCAAoC;AACtC;;AAEA,kCAAkC;AAClC;EACE,WAAW;EACX,WAAW,EAAE,yCAAyC;;EAEtD,+CAA+C;EAC/C;;;;GAIC;;EAED,2BAA2B;EAC3B;;;;;GAKC;;EAED,kBAAkB;EAClB,UAAU;EACV,8CAA8C;AAChD;;AAEA;EACE,UAAU;EACV,WAAW;EACX,cAAc;;EAEd,kDAAkD;EAClD,8EAA8E;;EAE9E;;;;;GAKC;;EAED,kBAAkB;EAClB,SAAS;EACT,UAAU;EACV,0CAA0C;AAC5C;;AAEA,oBAAoB;AACpB;EACE,WAAW,mDAAmD,EAAE;EAChE,WAAW,kDAAkD,EAAE;EAC/D,gBAAgB,mDAAmD,EAAE;EACrE,WAAW,kDAAkD,EAAE;AACjE;AACA;EACE,wDAAwD;AAC1D;;AAEA,wCAAwC;AACxC;EACE,mBAAmB;EACnB,UAAU;EACV,gBAAgB,EAAE,wBAAwB;EAC1C,aAAa;EACb,kBAAkB;EAClB,kBAAkB;EAClB,kBAAkB;EAClB,uCAAuC;EACvC,wBAAwB,EAAE,kBAAkB;EAC5C,WAAW;EACX,qCAAqC;AACvC;;AAEA,YAAY;AACZ;EACE,WAAW;EACX,kBAAkB;EAClB,UAAU;EACV,SAAS;EACT,2BAA2B;EAC3B,WAAW;EACX,YAAY;EACZ,gBAAgB;EAChB,mBAAmB;EACnB,UAAU;EACV,uCAAuC;AACzC;;AAEA;EACE,SAAS;EACT,eAAe;EACf,yBAAyB;EACzB,6BAA6B;EAC7B,oBAAoB;EACpB,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,eAAe;EACf,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,8BAA8B;EAC9B,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;EACjB,eAAe;AACjB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,yBAAyB;EACzB,kBAAkB;EAClB,iBAAiB;EACjB,qBAAqB;EACrB,yBAAyB;EACzB,UAAU;EACV,6EAA6E;EAC7E,mBAAmB;AACrB;;AAEA,aAAa,cAAc,EAAE,qBAAqB,EAAE;AACpD,cAAc,cAAc,EAAE,qBAAqB,EAAE;;AAErD;EACE,OAAO,UAAU,EAAE,kCAAkC,EAAE;EACvD,KAAK,YAAY,EAAE,kCAAkC,EAAE;AACzD;;AAEA;EACE,gBAAgB;EAChB,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,oBAAoB;EACpB,iBAAiB;EACjB,eAAe;EACf,WAAW;EACX,yBAAyB;EACzB,2BAA2B;AAC7B;AACA,qBAAqB,gBAAgB,EAAE;;AAEvC;EACE,OAAO,UAAU,EAAE;EACnB,KAAK,UAAU,EAAE;AACnB;;AAEA,yBAAyB;;AAEzB,2DAA2D;AAC3D;EACE,kBAAkB;EAClB,QAAQ,EAAE,SAAS;EACnB,gCAAgC;EAChC,QAAQ,EAAE,SAAS;EACnB,oBAAoB;EACpB,WAAW,EAAE,yBAAyB;AACxC;;AAEA,aAAa;AACb;EACE,kBAAkB;EAClB,WAAW,EAAE,YAAY;EACzB,sFAAsF;EACtF,kBAAkB;EAClB,SAAS,EAAE,WAAW;EACtB,UAAU;EACV,2CAA2C;AAC7C;;AAEA;EACE,KAAK,mCAAmC,EAAE,YAAY,EAAE;EACxD,OAAO,uCAAuC,EAAE,UAAU,EAAE;AAC9D;;AAEA,aAAa;AACb;EACE,kBAAkB;EAClB,UAAU,EAAE,WAAW;EACvB,gBAAgB;EAChB,kBAAkB;EAClB,4CAA4C;EAC5C,UAAU;AACZ;;AAEA,mCAAmC;AACnC,MAAM,0CAA0C,EAAE,WAAW,EAAE,WAAW,EAAE;AAC5E,MAAM,gDAAgD,EAAE,UAAU,EAAE,WAAW,EAAE;AACjF,MAAM,gDAAgD,EAAE,WAAW,EAAE,UAAU,EAAE;AACjF,MAAM,2CAA2C,EAAE,UAAU,EAAE,UAAU,EAAE;;AAE3E;EACE,KAAK,mCAAmC,EAAE,UAAU,EAAE,mBAAmB,EAAE;EAC3E,MAAM,UAAU,EAAE;EAClB,OAAO,mDAAmD,EAAE,UAAU,EAAE,mBAAmB,EAAE;AAC/F;;AAEA,0CAA0C;;AAE1C,uBAAuB;AACvB;EACE,aAAa;EACb,QAAQ;AACV;;AAEA;EACE,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,WAAW;AACb;;AAEA,qBAAqB;AACrB;EACE,cAAc;EACd,wCAAwC;AAC1C;;AAEA;EACE,OAAO,UAAU,EAAE;EACnB,KAAK,YAAY,EAAE;AACrB;;AAEA,yBAAyB;AACzB;EACE,cAAc;EACd,qBAAqB;EACrB,4CAA4C;AAC9C;;AAEA;EACE,cAAc;EACd,qBAAqB;EACrB,4CAA4C;AAC9C","sourcesContent":["/* --- ГЛАВНЫЙ КОНТЕЙНЕР (ДЕТОНАТОР) --- */\n.bomb-container {\n  position: fixed;\n  top: 50%; left: 50%; transform: translate(-50%, -50%);\n  width: 90%; max-width: 340px;\n  background: linear-gradient(145deg, #2b2b2b, #1a1a1a);\n  border: 1px solid #444; border-bottom: 6px solid #111; border-radius: 16px;\n  box-shadow: 0 20px 60px rgba(0,0,0,0.8), inset 0 1px 0 rgba(255,255,255,0.1);\n  padding: 20px; display: flex; flex-direction: column; gap: 15px;\n  font-family: 'Segoe UI', Roboto, Helvetica, Arial, sans-serif;\n  z-index: 6000; user-select: none;\n}\n.bomb-container::before, .bomb-container::after { content: ''; position: absolute; top: 10px; width: 8px; height: 8px; background: #111; border-radius: 50%; box-shadow: 0 1px 0 rgba(255,255,255,0.1); }\n.bomb-container::before { left: 10px; } .bomb-container::after { right: 10px; }\n\n/* --- ПАНЕЛЬ И ЭКРАН --- */\n.bomb-stats-bar { display: flex; justify-content: space-between; align-items: center; background: #000; padding: 8px 15px; border-radius: 8px; border: 1px solid #333; box-shadow: inset 0 2px 5px rgba(0,0,0,0.5); }\n.b-stat-group { display: flex; flex-direction: column; align-items: center; line-height: 1; }\n.b-label { font-size: 9px; color: #555; text-transform: uppercase; font-weight: 800; letter-spacing: 0.5px; margin-bottom: 2px; }\n.b-value { font-family: 'Courier New', monospace; font-weight: bold; font-size: 18px; color: #fff; text-shadow: 0 0 2px rgba(255,255,255,0.3); }\n.b-value.highlight { color: #f1c40f; } .b-value.danger { color: #e74c3c; }\n\n.bomb-screen { background: #080808; height: 140px; border-radius: 6px; border: 2px solid #333; position: relative; overflow: hidden; display: flex; flex-direction: column; align-items: center; justify-content: center; box-shadow: inset 0 0 15px rgba(0,0,0,0.9); }\n.bomb-screen::before { content: ''; position: absolute; top: 0; left: 0; right: 0; bottom: 0; background-image: linear-gradient(rgba(30, 255, 30, 0.03) 1px, transparent 1px), linear-gradient(90deg, rgba(30, 255, 30, 0.03) 1px, transparent 1px); background-size: 20px 20px; pointer-events: none; }\n.task-wrapper { z-index: 2; text-align: center; width: 100%; padding: 0 10px; }\n.task-main-text { font-size: 26px; font-weight: 900; text-transform: uppercase; letter-spacing: 1px; text-shadow: 0 0 10px rgba(0,0,0,0.5); line-height: 1.1; }\n.text-red { color: #ff3333; text-shadow: 0 0 5px rgba(255, 51, 51, 0.4); }\n.text-blue { color: #3388ff; text-shadow: 0 0 5px rgba(51, 136, 255, 0.4); }\n.text-green { color: #33ff33; text-shadow: 0 0 5px rgba(51, 255, 51, 0.4); }\n.text-yellow { color: #ffff33; text-shadow: 0 0 5px rgba(255, 255, 51, 0.4); }\n\n.timer-bar-container { position: absolute; bottom: 0; left: 0; right: 0; height: 8px; background: #111; }\n.timer-bar-fill { height: 100%; background: linear-gradient(90deg, #d23625, #b46c64); box-shadow: 0 0 10px #e74c3c; transition: width 0.05s linear; }\n.boom-overlay { position: absolute; inset: 0; background: rgba(200, 0, 0, 0.9); display: flex; align-items: center; justify-content: center; z-index: 10; animation: flash 0.2s ease-out; }\n.boom-text { font-size: 40px; font-weight: 900; color: #fff; border: 4px solid #fff; padding: 5px 15px; transform: rotate(-10deg); text-transform: uppercase; }\n\n/* --- ПРОВОДА (КНОПКИ) --- */\n.wires-grid {\n  display: grid; grid-template-columns: 1fr 1fr; gap: 12px; margin-top: 5px;\n  position: relative; z-index: 20;\n}\n\n.wire-btn {\n  background: #222; border-radius: 6px; height: 70px;\n  position: relative; /* Для z-index */\n  box-shadow: 0 4px 0 #000;\n  transition: transform 0.05s;\n  display: flex; align-items: center; justify-content: center;\n  padding: 0 10px;\n  overflow: visible; /* Чтобы кусачки торчали */\n  user-select: none;\n}\n\n.wire-btn:active { transform: translateY(2px); box-shadow: 0 2px 0 #000; }\n\n/* --- ВИЗУАЛ ПРОВОДА --- */\n/* ВАЖНО: pointer-events: none, чтобы elementFromPoint попадал в wire-btn */\n.wire-visual {\n  width: 100%; height: 12px; border-radius: 4px; position: relative;\n  box-shadow: inset 0 3px 3px rgba(255,255,255,0.3), inset 0 -3px 3px rgba(0,0,0,0.3), 0 2px 4px rgba(0,0,0,0.5);\n  z-index: 1; pointer-events: none;\n}\n.wire-visual::before, .wire-visual::after { content: ''; position: absolute; top: -2px; width: 10px; height: 16px; background: #111; border-radius: 2px; box-shadow: 0 1px 0 rgba(255,255,255,0.1); z-index: 2; }\n.wire-visual::before { left: -12px; } .wire-visual::after { right: -12px; }\n.btn-red .wire-visual { background: #e74c3c; } .btn-blue .wire-visual { background: #3498db; } .btn-green .wire-visual { background: #2ecc71; } .btn-yellow .wire-visual { background: #f1c40f; }\n\n.cut-gap-visual { position: absolute; left: 50%; top: 50%; transform: translate(-50%, -50%); width: 14px; height: 16px; background: #222; z-index: 3; display: flex; justify-content: space-between; align-items: center; }\n.copper-bit { width: 3px; height: 6px; background: linear-gradient(to bottom, #d48d56, #f5cba7, #a05a2c); border-radius: 1px; }\n.wire-is-cut { opacity: 0.9; }\n\n/* --- ИНСТРУМЕНТ (КУСАЧКИ) --- */\n.wire-cutter-tool {\n  position: absolute;\n  bottom: -150px; left: 50%; transform: translateX(-50%) scale(0.9);\n  width: 70px; height: 140px;\n  z-index: 100; opacity: 0;\n  pointer-events: none; /* ПРОПУСКАЕТ КЛИКИ */\n  transition: bottom 0.1s ease-out, opacity 0.1s ease-in;\n}\n\n.wire-cutter-tool.visible {\n  bottom: -95px; /* Высота, чтобы кончик касался провода */\n  opacity: 1; transform: translateX(-50%) scale(1);\n}\n\n/* Лезвия (Монолитные) */\n.cutter-jaws {\n  width: 100%; height: 35%;\n  clip-path: polygon(20% 100%, 50% 0%, 80% 100%);\n  background: conic-gradient(from 180deg at 50% 100%, #555 0deg, #999 45deg, #fff 55deg, #888 65deg, #444 90deg, #888 115deg, #fff 125deg, #999 135deg, #555 180deg);\n  position: relative; z-index: 2;\n  filter: drop-shadow(0 5px 5px rgba(0,0,0,0.5));\n}\n\n/* Ручки (Красные, без щели) */\n.cutter-handles {\n  width: 70%; height: 65%; margin: 0 auto;\n  background: linear-gradient(90deg, #800000, #ff0000 30%, #ff0000 70%, #800000);\n  clip-path: polygon(0% 0%, 100% 0%, 85% 100%, 15% 100%);\n  position: relative; top: -1px; z-index: 1;\n  box-shadow: inset 0 0 10px rgba(0,0,0,0.5);\n}\n\n/* Анимации и прочее */\n@keyframes shake { 10%, 90% { transform: translate(-50%, -50%) translate(-2px, 0); } 20%, 80% { transform: translate(-50%, -50%) translate(4px, 0); } 30%, 50%, 70% { transform: translate(-50%, -50%) translate(-6px, 0); } 40%, 60% { transform: translate(-50%, -50%) translate(6px, 0); } }\n.shake-anim { animation: shake 0.4s cubic-bezier(.36,.07,.19,.97) both; }\n\n/* Модалка результатов */\n.bomb-result-modal { background: #f4f4f4; width: 90%; max-width: 320px; padding: 25px; border-radius: 4px; text-align: center; position: relative; box-shadow: 0 20px 50px rgba(0,0,0,0.5); transform: rotate(-1deg); color: #333; font-family: 'Courier New', monospace; }\n.bomb-result-modal::before { content: ''; position: absolute; top: -15px; left: 50%; transform: translateX(-50%); width: 15px; height: 40px; background: #999; border-radius: 10px; z-index: 2; box-shadow: 1px 1px 2px rgba(0,0,0,0.3); }\n.result-header h2 { margin: 0; font-size: 24px; text-transform: uppercase; border-bottom: 2px solid #333; padding-bottom: 10px; margin-bottom: 20px; }\n.result-stats { margin-bottom: 25px; font-size: 16px; display: flex; flex-direction: column; gap: 10px; }\n.res-row { display: flex; justify-content: space-between; border-bottom: 1px dashed #ccc; padding-bottom: 3px; }\n.res-val { font-weight: bold; font-size: 20px; }\n.result-stamp { font-size: 32px; font-weight: 900; text-transform: uppercase; border: 5px double; padding: 5px 10px; display: inline-block; transform: rotate(-15deg); opacity: 0; animation: stampIn 0.4s 0.2s cubic-bezier(0.175, 0.885, 0.32, 1.275) forwards; margin-bottom: 20px; }\n.stamp-win { color: #27ae60; border-color: #27ae60; } .stamp-fail { color: #c0392b; border-color: #c0392b; }\n@keyframes stampIn { from { opacity: 0; transform: rotate(-15deg) scale(2); } to { opacity: 0.8; transform: rotate(-15deg) scale(1); } }\n.result-btn { background: #333; color: #fff; border: none; padding: 12px 24px; font-size: 16px; font-family: inherit; font-weight: bold; cursor: pointer; width: 100%; text-transform: uppercase; transition: background 0.2s; }\n.result-btn:active { background: #000; }\n@keyframes flash { from { opacity: 0; } to { opacity: 1; } }\n\n/* Болтики по углам */\n.bomb-container::before, .bomb-container::after {\n  content: '';\n  position: absolute;\n  top: 10px;\n  width: 8px;\n  height: 8px;\n  background: #111;\n  border-radius: 50%;\n  box-shadow: 0 1px 0 rgba(255,255,255,0.1);\n}\n.bomb-container::before { left: 10px; }\n.bomb-container::after { right: 10px; }\n\n/* --- ВЕРХНЯЯ ПАНЕЛЬ (ИНФО) --- */\n.bomb-stats-bar {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  background: #000;\n  padding: 8px 15px;\n  border-radius: 8px;\n  border: 1px solid #333;\n  box-shadow: inset 0 2px 5px rgba(0,0,0,0.5);\n}\n\n.b-stat-group {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  line-height: 1;\n}\n\n.b-label {\n  font-size: 9px;\n  color: #555;\n  text-transform: uppercase;\n  font-weight: 800;\n  letter-spacing: 0.5px;\n  margin-bottom: 2px;\n}\n\n.b-value {\n  font-family: 'Courier New', monospace;\n  font-weight: bold;\n  font-size: 18px;\n  color: #fff;\n  text-shadow: 0 0 2px rgba(255,255,255,0.3);\n}\n\n.b-value.highlight { color: #f1c40f; }\n.b-value.danger { color: #e74c3c; }\n\n/* --- ЭКРАН ЗАДАЧИ --- */\n.bomb-screen {\n  background: #080808;\n  height: 140px;\n  border-radius: 6px;\n  border: 2px solid #333;\n  position: relative;\n  overflow: hidden;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  box-shadow: inset 0 0 15px rgba(0,0,0,0.9);\n}\n\n/* Сетка на экране (декор) */\n.bomb-screen::before {\n  content: '';\n  position: absolute;\n  top: 0; left: 0; right: 0; bottom: 0;\n  background-image:\n    linear-gradient(rgba(30, 255, 30, 0.03) 1px, transparent 1px),\n    linear-gradient(90deg, rgba(30, 255, 30, 0.03) 1px, transparent 1px);\n  background-size: 20px 20px;\n  pointer-events: none;\n}\n\n.task-wrapper {\n  z-index: 2;\n  text-align: center;\n  width: 100%;\n  padding: 0 10px;\n}\n\n.task-main-text {\n  font-size: 26px; /* Крупнее, раз убрали иконки */\n  font-weight: 900;\n  text-transform: uppercase;\n  letter-spacing: 1px;\n  text-shadow: 0 0 10px rgba(0,0,0,0.5);\n  line-height: 1.1;\n}\n\n/* Цвета текста */\n.text-red { color: #ff3333; text-shadow: 0 0 5px rgba(255, 51, 51, 0.4); }\n.text-blue { color: #3388ff; text-shadow: 0 0 5px rgba(51, 136, 255, 0.4); }\n.text-green { color: #33ff33; text-shadow: 0 0 5px rgba(51, 255, 51, 0.4); }\n.text-yellow { color: #ffff33; text-shadow: 0 0 5px rgba(255, 255, 51, 0.4); }\n\n/* Таймер-полоска */\n.timer-bar-container {\n  position: absolute;\n  bottom: 0;\n  left: 0;\n  right: 0;\n  height: 8px;\n  background: #111;\n}\n\n.timer-bar-fill {\n  height: 100%;\n  background: linear-gradient(90deg, #d23625, #b46c64);\n  box-shadow: 0 0 10px #e74c3c;\n  transition: width 0.05s linear;\n}\n\n/* Оверлей взрыва */\n.boom-overlay {\n  position: absolute;\n  inset: 0;\n  background: rgba(200, 0, 0, 0.9);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  z-index: 10;\n  animation: flash 0.2s ease-out;\n}\n.boom-text {\n  font-size: 40px;\n  font-weight: 900;\n  color: #fff;\n  border: 4px solid #fff;\n  padding: 5px 15px;\n  transform: rotate(-10deg);\n  text-transform: uppercase;\n}\n\n/* --- ПРОВОДА И СЕТКА --- */\n.wires-grid {\n  display: grid;\n  grid-template-columns: 1fr 1fr;\n  gap: 12px;\n  margin-top: 5px;\n\n  /* Разрешаем элементам выходить за границы сетки (для ручек кусачек) */\n  position: relative;\n  z-index: 20;\n}\n\n.wire-btn {\n  background: #222;\n  border-radius: 6px;\n  height: 70px;\n  position: relative; /* Важно для z-index */\n  box-shadow: 0 4px 0 #000;\n  transition: transform 0.05s;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  padding: 0 10px;\n  overflow: visible;\n  user-select: none;\n  cursor: crosshair;\n}\n\n.wire-btn:active {\n  /* Убираем сильное смещение кнопки, так как мы теперь \"водим\" инструментом */\n  transform: translateY(1px);\n  box-shadow: 0 3px 0 #000;\n}\n\n/* Черные клеммы по бокам */\n.wire-visual::before, .wire-visual::after {\n  content: '';\n  position: absolute;\n  top: -2px;\n  width: 10px;\n  height: 16px;\n  background: #111;\n  border-radius: 2px;\n  box-shadow: 0 1px 0 rgba(255,255,255,0.1);\n  z-index: 2; /* Поверх провода */\n}\n.wire-visual::before { left: -12px; }\n.wire-visual::after { right: -12px; }\n\n/* Провод: ВАЖНО pointer-events: none */\n.wire-visual {\n  width: 100%; height: 12px; border-radius: 4px; position: relative;\n  box-shadow: inset 0 3px 3px rgba(255,255,255,0.3), inset 0 -3px 3px rgba(0,0,0,0.3), 0 2px 4px rgba(0,0,0,0.5);\n  z-index: 1;\n  pointer-events: none;\n}\n\n/* Цвета проводов */\n.btn-red .wire-visual { background: #e74c3c; }\n.btn-blue .wire-visual { background: #3498db; }\n.btn-green .wire-visual { background: #2ecc71; }\n.btn-yellow .wire-visual { background: #f1c40f; }\n\n/* --- ЭФФЕКТ РАЗРЕЗА --- */\n\n/* Контейнер разрыва по центру */\n.cut-gap-visual {\n  position: absolute;\n  left: 50%;\n  top: 50%;\n  transform: translate(-50%, -50%);\n  width: 14px;\n  height: 16px;\n  background: #222; /* Цвет должен совпадать с фоном кнопки */\n  z-index: 3;\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n}\n\n/* Медные кончики */\n.copper-bit {\n  width: 3px;\n  height: 6px; /* Уже чем сам провод (12px) */\n  background: linear-gradient(to bottom, #d48d56, #f5cba7, #a05a2c); /* Медный цвет */\n  border-radius: 1px;\n}\n.copper-bit.left { margin-left: -1px; }\n.copper-bit.right { margin-right: -1px; }\n\n/* Состояние: провод перерезан */\n.wire-is-cut {\n  cursor: default;\n  pointer-events: none;\n  opacity: 0.9;\n}\n/* Убираем тень при нажатии для перерезанного (чтобы не прыгал) */\n.wire-is-cut:active {\n  transform: none;\n  box-shadow: 0 4px 0 #000;\n}\n\n\n/* --- ИНСТРУМЕНТ (КУСАЧКИ) --- */\n\n.wire-cutter-tool {\n  position: absolute;\n  bottom: -150px;\n  left: 50%;\n  transform: translateX(-50%) scale(0.9);\n  width: 70px;\n  height: 140px;\n  z-index: 100;\n  opacity: 0;\n  /* ВАЖНО: Пропускаем клики сквозь инструмент, чтобы попасть в кнопку */\n  pointer-events: none;\n  transition: bottom 0.1s ease-out, opacity 0.1s ease-in;\n}\n\n/* АКТИВНЫЕ КУСАЧКИ */\n.wire-cutter-tool.visible {\n  /* Опускаем ниже: провод на высоте ~35px от низа кнопки. */\n  /* Высота кусачек 140px. Если bottom -100px, верх кусачек на высоте 40px */\n  bottom: -95px;\n  opacity: 1;\n  transform: translateX(-50%) scale(1);\n}\n\n/* 1. Лезвия (Верх) - МОНОЛИТНЫЕ */\n.cutter-jaws {\n  width: 100%;\n  height: 35%; /* Чуть короче, чтобы больше ручек было */\n\n  /* Форма: монолитный конус/трапеция, без щели */\n  clip-path: polygon(\n    20% 100%,  /* Левый низ */\n    50% 0%,    /* ОСТРИЕ (Верх) */\n    80% 100%   /* Правый низ */\n  );\n\n  /* Металлический градиент */\n  background: conic-gradient(\n    from 180deg at 50% 100%,\n    #555 0deg, #999 45deg, #fff 55deg, #888 65deg,\n    #444 90deg,\n    #888 115deg, #fff 125deg, #999 135deg, #555 180deg\n  );\n\n  position: relative;\n  z-index: 2;\n  filter: drop-shadow(0 5px 5px rgba(0,0,0,0.5));\n}\n\n.cutter-handles {\n  width: 70%;\n  height: 65%;\n  margin: 0 auto;\n\n  /* Исправлен цвет на яркий, непрозрачный красный */\n  background: linear-gradient(90deg, #800000, #ff0000 30%, #ff0000 70%, #800000);\n\n  clip-path: polygon(\n    0% 0%,\n    100% 0%,\n    85% 100%,\n    15% 100%\n  );\n\n  position: relative;\n  top: -1px;\n  z-index: 1;\n  box-shadow: inset 0 0 10px rgba(0,0,0,0.5);\n}\n\n/* Анимация тряски */\n@keyframes shake {\n  10%, 90% { transform: translate(-50%, -50%) translate(-2px, 0); }\n  20%, 80% { transform: translate(-50%, -50%) translate(4px, 0); }\n  30%, 50%, 70% { transform: translate(-50%, -50%) translate(-6px, 0); }\n  40%, 60% { transform: translate(-50%, -50%) translate(6px, 0); }\n}\n.shake-anim {\n  animation: shake 0.4s cubic-bezier(.36,.07,.19,.97) both;\n}\n\n/* --- РЕЗУЛЬТАТЫ (НОВАЯ КАРТОЧКА) --- */\n.bomb-result-modal {\n  background: #f4f4f4;\n  width: 90%;\n  max-width: 320px; /* Ограничиваем ширину */\n  padding: 25px;\n  border-radius: 4px;\n  text-align: center;\n  position: relative;\n  box-shadow: 0 20px 50px rgba(0,0,0,0.5);\n  transform: rotate(-1deg); /* Эффект бумаги */\n  color: #333;\n  font-family: 'Courier New', monospace;\n}\n\n/* Скрепка */\n.bomb-result-modal::before {\n  content: '';\n  position: absolute;\n  top: -15px;\n  left: 50%;\n  transform: translateX(-50%);\n  width: 15px;\n  height: 40px;\n  background: #999;\n  border-radius: 10px;\n  z-index: 2;\n  box-shadow: 1px 1px 2px rgba(0,0,0,0.3);\n}\n\n.result-header h2 {\n  margin: 0;\n  font-size: 24px;\n  text-transform: uppercase;\n  border-bottom: 2px solid #333;\n  padding-bottom: 10px;\n  margin-bottom: 20px;\n}\n\n.result-stats {\n  margin-bottom: 25px;\n  font-size: 16px;\n  display: flex;\n  flex-direction: column;\n  gap: 10px;\n}\n\n.res-row {\n  display: flex;\n  justify-content: space-between;\n  border-bottom: 1px dashed #ccc;\n  padding-bottom: 3px;\n}\n\n.res-val {\n  font-weight: bold;\n  font-size: 20px;\n}\n\n.result-stamp {\n  font-size: 32px;\n  font-weight: 900;\n  text-transform: uppercase;\n  border: 5px double;\n  padding: 5px 10px;\n  display: inline-block;\n  transform: rotate(-15deg);\n  opacity: 0;\n  animation: stampIn 0.4s 0.2s cubic-bezier(0.175, 0.885, 0.32, 1.275) forwards;\n  margin-bottom: 20px;\n}\n\n.stamp-win { color: #27ae60; border-color: #27ae60; }\n.stamp-fail { color: #c0392b; border-color: #c0392b; }\n\n@keyframes stampIn {\n  from { opacity: 0; transform: rotate(-15deg) scale(2); }\n  to { opacity: 0.8; transform: rotate(-15deg) scale(1); }\n}\n\n.result-btn {\n  background: #333;\n  color: #fff;\n  border: none;\n  padding: 12px 24px;\n  font-size: 16px;\n  font-family: inherit;\n  font-weight: bold;\n  cursor: pointer;\n  width: 100%;\n  text-transform: uppercase;\n  transition: background 0.2s;\n}\n.result-btn:active { background: #000; }\n\n@keyframes flash {\n  from { opacity: 0; }\n  to { opacity: 1; }\n}\n\n/* --- ЭФФЕКТЫ (FX) --- */\n\n/* Контейнер эффектов: Центрируется ровно в месте разреза */\n.fx-container {\n  position: absolute;\n  top: 50%; left: 50%;\n  transform: translate(-50%, -50%);\n  width: 0; height: 0;\n  pointer-events: none;\n  z-index: 20; /* Поверх медных концов */\n}\n\n/* 1. ДЫМОК */\n.fx-smoke {\n  position: absolute;\n  width: 20px; height: 20px;\n  background: radial-gradient(circle, rgba(200,200,200,0.8) 0%, rgba(100,100,100,0) 70%);\n  border-radius: 50%;\n  top: -5px; left: -10px;\n  opacity: 0;\n  animation: puffSmoke 0.5s ease-out forwards;\n}\n\n@keyframes puffSmoke {\n  0% { transform: scale(0.5) translateY(0); opacity: 0.8; }\n  100% { transform: scale(2.5) translateY(-30px); opacity: 0; }\n}\n\n/* 2. ИСКРЫ */\n.fx-spark {\n  position: absolute;\n  width: 4px; height: 4px;\n  background: #fff;\n  border-radius: 50%;\n  box-shadow: 0 0 4px #ffcc00, 0 0 8px #ff6600;\n  opacity: 0;\n}\n\n/* Разные направления полета искр */\n.s1 { animation: sparkFly 0.3s ease-out forwards; --dx: -15px; --dy: -20px; }\n.s2 { animation: sparkFly 0.4s ease-out 0.05s forwards; --dx: 15px; --dy: -25px; }\n.s3 { animation: sparkFly 0.3s ease-out 0.02s forwards; --dx: -10px; --dy: 10px; }\n.s4 { animation: sparkFly 0.35s ease-out forwards; --dx: 10px; --dy: 15px; }\n\n@keyframes sparkFly {\n  0% { transform: translate(0, 0) scale(1); opacity: 1; background: #ffffcc; }\n  50% { opacity: 1; }\n  100% { transform: translate(var(--dx), var(--dy)) scale(0); opacity: 0; background: #ff4400; }\n}\n\n/* --- НОВЫЕ СТИЛИ ДЛЯ SURVIVAL MODE --- */\n\n/* Отображение ошибок */\n.strikes-container {\n  display: flex;\n  gap: 4px;\n}\n\n.strike-icon {\n  color: #e74c3c;\n  font-size: 18px;\n}\n\n.strike-icon.inactive {\n  color: #333;\n}\n\n/* Таймер выживания */\n.survival-timer.danger {\n  color: #ff3333;\n  animation: pulse 0.5s infinite alternate;\n}\n\n@keyframes pulse {\n  from { opacity: 1; }\n  to { opacity: 0.6; }\n}\n\n/* Состояния конца игры */\n.stamp-exploded {\n  color: #e74c3c;\n  border-color: #e74c3c;\n  text-shadow: 0 0 10px rgba(231, 76, 60, 0.8);\n}\n\n.stamp-survived {\n  color: #27ae60;\n  border-color: #27ae60;\n  text-shadow: 0 0 10px rgba(39, 174, 96, 0.8);\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
